import { createAction } from '@af-common/Common/_actions/Action';
import { ModuleTypes } from '../../Module/_config/ModuleInfo';

export enum ModuleListActionType {
	OnModuleAdd		= 'ON_MODULE_ADD',
	OnModuleRemove	= 'ON_MODULE_REMOVE',
	OnModuleSelect	= 'ON_MODULE_SELECT',
	OnModuleMove	= 'ON_MODULE_MOVE',
}

export const OnModuleAdd = (id: string, type: ModuleTypes) => createAction(ModuleListActionType.OnModuleAdd, {
	id: id,
	moduleType: type
});

export const OnModuleRemove = (id: string) => createAction(ModuleListActionType.OnModuleRemove, {
	id: id
});

export const OnModuleSelect = (id: string) => createAction(ModuleListActionType.OnModuleSelect, {
	id: id
});

export const OnModuleMove = (id: string, position: number) => createAction(ModuleListActionType.OnModuleMove, {
	id: id,
	position: position
});

export type ModuleListAction = 
	ReturnType<typeof OnModuleAdd>		|
	ReturnType<typeof OnModuleRemove>	|
	ReturnType<typeof OnModuleSelect>	|
	ReturnType<typeof OnModuleMove>